/** Shared, cross-screen copy. Plain language only (UX_SPEC §0.1, §0.4). */
export const common = {
  brand: "Carno",
  goHome: "Go to Home",
  /** Logo link: must contain the visible "Carno" (WCAG 2.5.3). */
  logoLink: "Carno, go to Home",
  backToHome: "Back to Home",
  tryAgain: "Try again",
  cancel: "Cancel",
  close: "Close",
  done: "Done",
  copy: "Copy",
  copied: "Copied",
  copyLink: "Copy link",
  linkCopied: "Link copied",
  undo: "Undo",
  saved: "Saved",
  saving: "Saving…",
  loading: "Loading…",
  more: "More",
  showMore: "Show more",
  you: "You",
  youSuffix: "(you)",
  details: "Details",
  share: "Share",
  open: "Open",
  openInNewTab: "Open in new tab",
  rename: "Rename",
  search: "Search",
  clearSearch: "Clear search",
  offlineBanner: "You're offline. Changes will be saved when you're back.",
  availableWhenOnline: "Available when you're back online.",
  copyFailed: "Couldn't copy. Select the text and copy it yourself.",
  optional: "(optional)",
  show: "Show",
  hide: "Hide",
  skipToContent: "Skip to content",
  time: {
    justNow: "just now",
    minutesAgo: (n: number) => `${n} min ago`,
    hoursAgo: (n: number) => `${n}h ago`,
    today: "Today",
    yesterday: "Yesterday",
  },
  changed: (when: string) => `Changed ${when}`,
} as const;
